import i18n from "i18next";
import {call, put, takeLatest} from "redux-saga/effects";
import {cToast} from "helpers";
import licencePlatesService from "./api";
import {licenseplatesActions} from "./data";



function* fetchLicencePlatesByDates({payload}){
    try{
        const data = yield call(licencePlatesService.getLicencePlateByDate, payload);
        yield put(licenseplatesActions.fetchLicencePlatesByDatesSuccess(data));
    }catch (err) {
        yield put(licenseplatesActions.fetchLicencePlatesByDatesFailure(err));
        yield cToast({msg: i18n.t("Something went wrong"),variant:'error'});
    }
}

function* fetchLicencePlatesByDeviceIds({payload}){
    try{
        const data = yield call(licencePlatesService.getLicencePlateByDeviceIds, payload);
        yield put(licenseplatesActions.fetchLicencePlatesByDeviceIdsSuccess(data));
    }catch (err) {
        yield put(licenseplatesActions.fetchLicencePlatesByDeviceIdsFailure(err));
        yield cToast({msg: i18n.t("Something went wrong"),variant:'error'});
    }
}

function* fetchLicencePlatesStatsCount({payload}){
    try{
        const data = yield call(licencePlatesService.getLicencePlateStatisticsCount, payload);
        yield put(licenseplatesActions.fetchLicencePlatesStatsCountSuccess(data));
    }catch (err) {
        yield put(licenseplatesActions.fetchLicencePlatesStatsCountFailure(err));
        yield cToast({msg: i18n.t("Something went wrong"),variant:'error'});
    }
}

function* fetchLicencePlatesStatsRegions({payload}){
    try{
        const data = yield call(licencePlatesService.getLicencePlateStatisticsRegions, payload);
        yield put(licenseplatesActions.fetchLicencePlatesStatsRegionsSuccess(data));
    }catch (err) {
        yield put(licenseplatesActions.fetchLicencePlatesStatsRegionsFailure(err));
        yield cToast({msg: i18n.t("Something went wrong"),variant:'error'});
    }
}

function* fetchLicencePlatesStatsMeanStopTimeMinutes({payload}){
    try{
        const data = yield call(licencePlatesService.getLicencePlateStatisticsMeanStopTimeMinutes, payload);
        yield put(licenseplatesActions.fetchLicencePlatesStatsMeanStopTimeMinutesSuccess(data));
    }catch (err) {
        yield put(licenseplatesActions.fetchLicencePlatesStatsMeanStopTimeMinutesFailure(err));
        yield cToast({msg: i18n.t("Something went wrong"),variant:'error'});
    }
}


function* fetchLicencePlateReportRegionsCsv({payload}){
    try{
        yield call(licencePlatesService.getLicencePlateReportRegionsCsv, payload);
        yield put(licenseplatesActions.fetchLicencePlateReportRegionsCsvSuccess());
    }catch (err) {
        yield put(licenseplatesActions.fetchLicencePlateReportRegionsCsvFailure(err));
        yield cToast({msg: i18n.t("Something went wrong"),variant:'error'});
    }
}

function* fetchLicencePlateReportCountPerHourCsv({payload}){
    try{
        yield call(licencePlatesService.getLicencePlateReportCountPerHourCsv, payload);
        yield put(licenseplatesActions.fetchLicencePlateReportCountPerHourCsvSuccess());
    }catch (err) {
        yield put(licenseplatesActions.fetchLicencePlateReportCountPerHourCsvFailure(err));
        yield cToast({msg: i18n.t("Something went wrong"),variant:'error'});
    }
}

export default function* licencePlatesSaga(){
    yield takeLatest(licenseplatesActions.fetchLicencePlatesByDates.type, fetchLicencePlatesByDates);
    yield takeLatest(licenseplatesActions.fetchLicencePlatesByDeviceIds.type, fetchLicencePlatesByDeviceIds);
    yield takeLatest(licenseplatesActions.fetchLicencePlatesStatsCount.type, fetchLicencePlatesStatsCount);
    yield takeLatest(licenseplatesActions.fetchLicencePlatesStatsRegions.type, fetchLicencePlatesStatsRegions);
    yield takeLatest(licenseplatesActions.fetchLicencePlatesStatsMeanStopTimeMinutes.type, fetchLicencePlatesStatsMeanStopTimeMinutes);
    yield takeLatest(licenseplatesActions.fetchLicencePlateReportRegionsCsv.type, fetchLicencePlateReportRegionsCsv);
    yield takeLatest(licenseplatesActions.fetchLicencePlateReportCountPerHourCsv.type, fetchLicencePlateReportCountPerHourCsv);
}